var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivityTypeAdmin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DCEAFA",
    width: 27,
    height: 27,
    rx: 10.916
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.462 2.842c1.46 0 2.645 1.247 2.645 2.785s-1.184 2.785-2.645 2.785c-1.462 0-2.646-1.247-2.646-2.785S12 2.842 13.462 2.842m-.857 6.838c2.066-.61 4.152 2.03 2.397 5.128-1.189 2.073-.584 3.906-1.676 4.211-1.91.524-4.815-8.138-.721-9.338M5.68 8.937c-.69.84-.082 2.335 1.562 2.117 1.1-.135 1.709.487 2.07.05.625-.773-2.268-3.813-3.632-2.167m1.329 11.656c-.689-.842-.058-2.328 1.569-2.113 1.09.156 1.722-.489 2.066-.04.632.803-2.277 3.815-3.635 2.153M20.86 6.422c1.102 1.004.513 3.104-1.788 3.123-1.54 0-2.262.965-2.832.435-.989-.946 2.452-5.545 4.62-3.558M17.301 20.84c-1.252-.428-1.58-1.383-2.196-1.11-1.11.448.39 4.984 2.75 4.03 1.192-.486 1.315-2.277-.554-2.92z",
    fill: "#61A0EA"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTypeAdmin);
export default __webpack_public_path__ + "static/media/activity-type-admin.c68acba74109d99d8f505ae340d71722.svg";
export { ForwardRef as ReactComponent };